import Logo from 'components/layout/logo';
import SwitchComponent from 'components/internationalization_switch';
import { CheckIcon } from 'components/uiIcons';
import { Navigate, Outlet } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { isAuthenticated } from 'utils/authentication';
import { WebsiteLink, DashboardLink } from 'utils/link';
import { StyledLink } from 'components/styles_components/link';
import {
  AuthLayoutContainer,
  AuthBrandingSection,
  AuthBrandingContent,
  AuthBrandingLogoRow,
  AuthBrandingHeroSection,
  AuthBrandingHeadline,
  AuthBrandingDescription,
  AuthBrandingFeatureList,
  AuthBrandingFeatureItem,
  AuthBrandingFeatureIcon,
  AuthBrandingFeatureText,
  AuthBrandingCopyright,
  AuthFormSection,
  AuthFormWrapper,
  AuthMobileHeader,
  AuthMobileLogoRow,
  AuthFormCard,
  AuthDesktopLanguageSwitcher,
} from 'components/styles_components/auth';

const features = ['auth.landing.feature1', 'auth.landing.feature2', 'auth.landing.feature3'];

const BrandingPanel = () => (
  <AuthBrandingSection>
    <AuthBrandingContent>
      <AuthBrandingLogoRow>
        <StyledLink to={WebsiteLink()}>
          <Logo width={40} />
        </StyledLink>
      </AuthBrandingLogoRow>
      <AuthBrandingHeroSection>
        <AuthBrandingHeadline variant="h2">
          <FormattedMessage id="auth.landing.headline" />
        </AuthBrandingHeadline>
        <AuthBrandingDescription>
          <FormattedMessage id="auth.landing.description" />
        </AuthBrandingDescription>
        <AuthBrandingFeatureList>
          {features.map((featureId) => (
            <AuthBrandingFeatureItem key={featureId}>
              <AuthBrandingFeatureIcon>
                <CheckIcon />
              </AuthBrandingFeatureIcon>
              <AuthBrandingFeatureText>
                <FormattedMessage id={featureId} />
              </AuthBrandingFeatureText>
            </AuthBrandingFeatureItem>
          ))}
        </AuthBrandingFeatureList>
      </AuthBrandingHeroSection>
      <AuthBrandingCopyright>
        <FormattedMessage id="footer.copyright" values={{ year: new Date().getFullYear() }} />
      </AuthBrandingCopyright>
    </AuthBrandingContent>
  </AuthBrandingSection>
);

const PublicAuthRoute = () => {
  if (isAuthenticated()) {
    return <Navigate to={DashboardLink()} />;
  }

  return (
    <AuthLayoutContainer>
      <BrandingPanel />
      <AuthFormSection>
        <AuthDesktopLanguageSwitcher>
          <SwitchComponent />
        </AuthDesktopLanguageSwitcher>
        <AuthFormWrapper>
          <AuthMobileHeader>
            <AuthMobileLogoRow>
              <StyledLink to={WebsiteLink()}>
                <Logo width={40} />
              </StyledLink>
            </AuthMobileLogoRow>
            <SwitchComponent />
          </AuthMobileHeader>
          <AuthFormCard>
            <Outlet />
          </AuthFormCard>
        </AuthFormWrapper>
      </AuthFormSection>
    </AuthLayoutContainer>
  );
};

export default PublicAuthRoute;
